import { object, ObjectSchema, string } from 'yup';

import { InvoicingIntegration, InvoicingIntegrationExternalReferenceValue } from '@client/api';

const schema: ObjectSchema<InvoicingIntegrationExternalReferenceValue> = object({
  integration: string<InvoicingIntegration>().required(),
  identifier: string().required()
});

export { schema as invoicingIntegrationExternalReferenceValueSchema };
